import React, { useState } from 'react';
import './css/login.css';

import slide1 from '../images/slides/slide1.jpg'
import slide2 from '../images/slides/slide2.jpg'
import slide3 from '../images/slides/slide3.jpg'
import slide4 from '../images/slides/slide4.jpg'

const slideTextArray = [
    "Get access to our amazing health care packages from over a hundred hospitals that are registered with us.",
    "At CarePlus, there is a health care package for every budget. We offer amazing health care plans.",
    "We have you covered! You can rest assured that we'll take care of all your health necessities while securing all of your data.",
    "We care about your opinion. Your feedback is important to us as our main objective is to serve you better.",
    "Get access to our amazing health care packages from over a hundred hospitals that are registered with us.",
    "At CarePlus, there is a health care package for every budget. We offer amazing health care plans.",
    "We have you covered! You can rest assured that we'll take care of all your health necessities while securing all of your data.",
    "We care about your opinion. Your feedback is important to us as our main objective is to serve you better.",
    "At CarePlus, there is a health care package for every budget. We offer amazing health care plans."
  ]

const slideArray = [slide1, slide2, slide3, slide4]

const SlideContainer = () => {
  const [slideIndex, setSlideIndex] = useState(0);

  const NextSlide = () => {
    setSlideIndex(slideIndex < 3 ? slideIndex + 1 : 0);
    
    clearInterval(timer);
  }

  // function SelectSlide(index) {
  //   console.log(index)
  //   setSlideIndex(index);

  //   clearInterval(timer);
  // }
  let timer = setInterval(NextSlide, 5000);

  return (
    <div className="slide_container">
      <div className="slide_box">
        <div className="slide_wrap" style={{backgroundImage: slideIndex < 3 ? "url(" + slideArray[slideIndex + 1] + ")" : "url(" + slideArray[0] + ")"}}>
          <img id="slide_image" className="slide_image" src={slideArray[0]} style={{display: slideIndex === 0 ? "block" : "none"}} alt="slide" />
          <img id="slide_image" className="slide_image" src={slideArray[1]} style={{display: slideIndex === 1 ? "block" : "none"}} alt="slide" />
          <img id="slide_image" className="slide_image" src={slideArray[2]} style={{display: slideIndex === 2 ? "block" : "none"}} alt="slide" />
          <img id="slide_image" className="slide_image" src={slideArray[3]} style={{display: slideIndex === 3 ? "block" : "none"}} alt="slide" />
        </div>
        <div className="slide_text_box">
          <h6 id="slide_text" className="slide_text">{slideTextArray[slideIndex]}</h6>
        </div>
      </div>
    </div>
  )
}

export default SlideContainer;